// extracted by mini-css-extract-plugin
module.exports = {"layoutPadding":"d_g","main":"d_h d_g"};